module.exports = __webpack_public_path__ + "f36cae5675b6b651dde30c7aa14f9c21.svg";